import React from "react";
import Modal from "react-bootstrap/Modal";
import CloseButton from "react-bootstrap/CloseButton";
import "./CenteredModal.css";

function CenteredModal({
  headerContent,
  bodyContent,
  footerContent,
  setShow,
  isStatic,
  size,
  backdropClassName,
  showReturnArrow = false,
  showCloseButton = true,
  onReturnArrowClick,
  ...props
}) {
  // Use object to add props conditionally
  const modalProps = {
    onHide: () => setShow(false),
    ...(size && { size: size }),
    className: "centered-modal",

    backdrop: isStatic ? "static" : true,
    keyboard: !isStatic,
    centered: true,
  };
  if (backdropClassName) modalProps.backdropClassName = backdropClassName;
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      {...modalProps}
    >
      <Modal.Body>
        <div className="btn-float">
          {showReturnArrow && (
            <i
              className="bi bi-arrow-left return-arrow"
              onClick={onReturnArrowClick}
            ></i>
          )}
          {showCloseButton && (
            <CloseButton
              variant="white"
              onClick={() => {
                setShow(false);
              }}
            />
          )}
        </div>
        {bodyContent}
      </Modal.Body>
    </Modal>
  );
}

export default CenteredModal;
